import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

/**
 * Configure and initialize GLightbox gallery
 * @returns {GLightbox} The configured lightbox instance
 */
function initGallery(): GLightbox {
  return GLightbox({
    selector: '.glightbox',  // Use the class from your template
    touchNavigation: true,
    loop: false,
    openEffect: 'zoom',
    closeEffect: 'fade',
    cssEffects: {
      fade: { in: 'fadeIn', out: 'fadeOut' },
      zoom: { in: 'zoomIn', out: 'zoomOut' }
    }
  });
}

/**
 * Initialize gallery when DOM is ready
 */
function init(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
}

// Execute initialization
init();
